<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="90px">
      <el-form-item label="规则名称" prop="name">
        <el-input v-model="queryParams.name" placeholder="请输入规则名称" clearable @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <!-- <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button> -->
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" plain icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button>
      </el-col>
      <el-col :span="1.5" v-if="dateRange.length > 0 && dateRange.length != null">
        <el-button type="warning" plain icon="el-icon-download" size="mini" @click="handleExport">导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="companyList">
      <el-table-column label="规则名称" align="center" prop="name" />
      <el-table-column label="补卡次数" align="center" prop="repairNum" />
      <el-table-column label="时间范围(天)" align="center" prop="timeFrame" />
      <el-table-column label="添加时间" align="center" prop="createTime" />
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button icon="el-icon-search" circle size="mini" @click="handleEdits(scope.row)"></el-button>
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" class="el-icon-delete" @click="handleDelete(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--新增编辑界面-->
    <el-drawer
      :title="title"
      :visible.sync="open"
      :before-close="handleClose"
      destroy-on-close
      class="headerts editdrawer"
      size="30%"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        style="padding-right: 30px"
        :disabled="title == '详情'"
      >
        <el-col :span="24">
          <el-form-item label="规则名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入规则名称" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="补卡次数" prop="repairNum">
            <el-input type="Number" v-model="form.repairNum" placeholder="请输入补卡次数">
              <template slot="append">次</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="时间范围" prop="timeFrame">
            <el-input type="Number" v-model="form.timeFrame" placeholder="请输入时间范围">
              <template slot="append">天</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="dialog-footer" v-if="title !== '详情'">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { repairRuleList, updateRepairRule, addRepairRule, delRepairRule } from '@/api/clockIn'

export default {
  name: 'Company',
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 公司表格数据
      companyList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        // pageNum: 1,
        // pageSize: 10,
        name: null,
        platformId: this.$route.query.platformId,
        companyId: this.$route.query.EId,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        name: [
          {
            required: true,
            message: '请输入补卡规则名称',
            trigger: 'blur',
          },
        ],
        repairNum: [
          {
            required: true,
            message: '请输入补卡此次数',
            trigger: 'blur',
          },
        ],
        timeFrame: [
          {
            required: true,
            message: '请输入时间范围',
            trigger: 'blur',
          },
        ],
      },
      // 日期范围
      dateRange: [],
      userId: '',
    }
  },
  created() {
    this.userId = this.$route.query.userId
    console.log(this.userId)
    this.getList()
  },
  methods: {
    /** 查询公司列表 */
    getList() {
      this.loading = true

      repairRuleList(this.queryParams).then((response) => {
        if (response.code == 200) {
          this.companyList = response.data
          this.loading = false
        }
      })
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        name: null,
        repairNum: null,
        timeFrame: null,
        createBy: this.userId,
        platformId: this.$route.query.platformId,
        companyId: this.$route.query.EId,
        createTime: null,
      }
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm')
      this.handleQuery()
    },

    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.title = '新增'
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset()
      this.form = Object.assign({}, row)
      // this.form.companyId = '734f53dacf1444c683fd1936ff1b77a1'
      this.open = true
      this.title = '修改'
    },
    /** 查看按钮操作 */
    handleEdits(row) {
      this.reset()
      this.form = Object.assign({}, row)
      this.open = true
      this.title = '详情'
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateRepairRule(this.form).then((response) => {
              this.$message({
                message: '修改成功',
                type: 'success',
              })
              this.open = false
              this.getList()
            })
          } else {
            addRepairRule(this.form).then((response) => {
              this.$message({
                message: '新增成功',
                type: 'success',
              })
              this.open = false
              this.getList()
            })
          }
        }
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids
      this.$confirm('是否确认删除该考勤规则？', '提示', { type: 'warning' }).then(() => {
        this.editLoading = true
        delRepairRule(ids).then((res) => {
          if (res.code === 200) {
            this.$message({ message: '删除成功', type: 'success' })
            this.getList()
          } else {
            this.$message({ message: '删除失败, ' + res.msg, type: 'error' })
          }
        })
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      if (this.dateRange.length != 0) {
        // this.queryParams.firstDay = this.dateRange[0]
        // this.queryParams.lastDay = this.dateRange[1]
        var firstDay = this.dateRange[0]
        var lastDay = this.dateRange[1]
      } else {
        // this.queryParams.firstDay = undefined
        // this.queryParams.lastDay = undefined
        var firstDay = undefined
        var lastDay = undefined
      }
      var params = {
        firstDay: firstDay,
        lastDay: lastDay,
      }
      this.download(
        'OA/unlockRecord/export',
        {
          ...params,
        },
        `考勤记录_${new Date().getTime()}.xlsx`
      )
    },
    // 弹框退出事件
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style>
.dialog-footer {
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
}
</style>
